import React from 'react';

function MinusLight() {
  return (
    <svg width="20" height="2" viewBox="0 0 20 2" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M19.75 1C19.75 1.42188 19.375 1.75 19 1.75H1C0.578125 1.75 0.25 1.42188 0.25 1C0.25 0.625 0.578125 0.25 1 0.25H19C19.375 0.25 19.75 0.625 19.75 1Z" fill="currentColor" />
    </svg>
  );
}

export { MinusLight };
